<template>
  <div class="dataBase">
    <lh-button v-if="executeInfo" @click="visible=true">更新数据库</lh-button>
    <lh-dialog v-if="executeInfo" :visible.sync="visible">
      <div slot="title">更新内容</div>
      <div>
        <div v-for="(log,index) of executeInfo.logList" :key="index">
          {{ log }}
        </div>
      </div>
      <div slot="footer">
        <lh-button :disabled="executeInfo.executed" @click="executeTask">确认</lh-button>
      </div>
    </lh-dialog>
  </div>
</template>

<script>
import axios from "../../../../utils/request";
export default {
  name:"DataBase",
  data(){
    return {
      visible:false,
      executeInfo:null
    }
  },
  mounted(){
    this.$lhLoading.open("加载中...");
    axios.get("/dataBase/getExecuteInfo").then((data)=>{
      this.executeInfo=data;
    }).catch((err)=>{
      this.$lhMessage("error",err.message);
    }).finally(()=>{
      this.$lhLoading.close();
    })
  },
  methods:{
    executeTask:function(){
      this.$lhLoading.open("请求中...");
      axios.post("/dataBase/executeTask").then(()=>{
        this.executeInfo.executed=true;
        this.$lhMessage("success","更新成功");
      }).catch((err)=>{
        this.$lhMessage("error",err.message);
      }).finally(()=>{
        this.$lhLoading.close();
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dataBase{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>